import { createReducer, on, Action } from '@ngrx/store';
import {
  KnownPostcodeTicketVerifyResponseStatus,
  PostcodeTicketVerifyOperationResponse,
} from '../../client/src';
import { LoadState } from '@nx-ng/types';
import { PostcodeChildTicketVerifyActions } from '../../actions';
import { ApiError } from '@modules/ticket-fares-store';
import { VerifyChildPostcodeTicket } from '@modules/checkout-store/types';

export interface IPostcodeChildTicketVerifyEntry {
  loaded: LoadState;
  status: string;
  request: VerifyChildPostcodeTicket;
}

export interface IPostcodeChildTicketVerifyState {
  [ticket: number]: IPostcodeChildTicketVerifyEntry;
}

export const initialState: IPostcodeChildTicketVerifyState = {};

const postcodeChildTicketVerifyReducer = createReducer(
  initialState,
  on(
    PostcodeChildTicketVerifyActions.clearAllPostcodeChildVerifications,
    () => {
      return initialState;
    }
  ),
  on(
    PostcodeChildTicketVerifyActions.verifyPostcodeChildTicket,
    (state, { verify }) => ({
      ...state,
      [verify.ticketID]: {
        loaded: LoadState.LOADING,
        status: KnownPostcodeTicketVerifyResponseStatus.Unverified,
        request: verify,
      },
    })
  ),
  on(
    PostcodeChildTicketVerifyActions.checkoutAPI_verifyPostcodeChildTicketSuccess,
    (
      state,
      {
        response,
        verify,
      }: {
        response: PostcodeTicketVerifyOperationResponse;
        verify: VerifyChildPostcodeTicket;
      }
    ) => ({
      ...state,
      [verify.ticketID]: {
        loaded: LoadState.LOADED,
        status: response.status,
        request: verify,
      },
    })
  ),
  on(
    PostcodeChildTicketVerifyActions.checkoutAPI_verifyPostcodeChildTicketFailure,
    (
      state,
      {
        error,
        verify,
      }: { error?: string | ApiError; verify: VerifyChildPostcodeTicket }
    ) => ({
      ...state,
      [verify.ticketID]: {
        loaded: LoadState.FAILED,
        status: KnownPostcodeTicketVerifyResponseStatus.Unverified,
        request: verify,
      },
    })
  )
);

export function reducer(
  state: IPostcodeChildTicketVerifyState | undefined,
  action: Action
) {
  return postcodeChildTicketVerifyReducer(state, action);
}
